// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"ZK5e7p9C"};